module ds_cluster_ui {

   import IController = angular.IController;
   import SdrsRulesService = ds_cluster_ui.SdrsRulesService;

   class VmdkAntiAffinityRuleDetailsController implements IController {
      static $inject = ["$rootScope", "i18nService", "sdrsRulesService"];
      public gridOptions: any;
      public ruleDetailsTitle: string;
      public ruleDetailsDescription: string;
      public selectedRuleDetails: any;

      constructor(private $rootScope: any, private i18nService: any,
            private sdrsRulesService: SdrsRulesService) {

         this.ruleDetailsTitle = i18nService.getString("DsClusterUi",
               "manage.settings.sdrsRuleDetails");
         this.ruleDetailsDescription = i18nService.getString("DsClusterUi",
               "sdrs.rules.view.vmdk.details.hint");
      }

      public $onChanges(changes: any): void {
         if (typeof changes.rule !== "undefined") {
            this.gridOptions = this.sdrsRulesService.getVmdkDetailsGridOptions();

            this.sdrsRulesService.getVmdkDetailsViewData(changes.rule.currentValue)
                  .then((data: any) => {
                     this.selectedRuleDetails = {
                        "data": data,
                        "formattedData": () => {
                           return _.map(data, (member: any) => {
                              return {
                                 "name": member.name,
                                 "rawData": {
                                    deviceInfo: {
                                       label: member.deviceInfo.label
                                    }
                                 }
                              };
                           });
                        }
                     };

                     this.gridOptions.data = data;
                  });
         }
      }
   }

   class VmdkAntiAffinityRuleDetailsComponent implements ng.IComponentOptions {
      public controller: any;
      public templateUrl: string;
      public bindings: any;

      constructor() {
         this.controller = VmdkAntiAffinityRuleDetailsController;
         this.templateUrl =
               "ds-cluster-ui/resources/ds-cluster/views/settings/configuration/rules/" +
               "vmAndVmdkAntiAffinityRuleDetailsComponent.html";
         this.bindings = {
            rule: "<",
            selectedRuleDetails: "="
         };
      }
   }

   angular.module("com.vmware.vsphere.client.dsCluster").component(
         "vmdkAntiAffinityRuleDetailsComponent",
               new VmdkAntiAffinityRuleDetailsComponent());
}
